// 全局流程相关变量
const modelerStore = {
  'userList': [],
  'roleList': [],
  'expList': [],
  'modeler': null,
  'modeling': null,
  'moddle': null,
  'canvas': null,
  'bpmnFactory': null,
  'elRegistry': null,
  'element': null,

}
export default
{
  modelerStore,
}
